"use strict";

/* eslint-disable react/no-string-refs */

/*
Creates a rich text editor using our internal draft.js implementation
 - Be sure to load asynchonously using `RequireAsync` mixin

 RequireAsync([
    {
      names: RichTextEditorModules
      callback: 'update' ## this.forceUpdate()
    }
  ])

  Example:

  <RichTextEditor
  focus={true}
  unstyled={true}
  className="myClassName"
  editorState={EditorState.createEmpty()}
  onSave={this.onSave}
  onChange={handleChange}
  onContentChange={handleContentChange}
  onCancel={this.onCancel}
  config={this.RichTextEditorEngagementConfigurations.get(TASK)}
  editorOptions={spellCheck: true}
/>
*/
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _classnames = _interopRequireDefault(require("classnames"));

var _draftExtend = require("draft-extend");

var _draftJs = require("draft-js");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _RichTextEditorConfiguration = _interopRequireDefault(require("../config/RichTextEditorConfiguration"));

var _RichTextEditorResults = _interopRequireDefault(require("../state/RichTextEditorResults"));

var _RichTextEditorStateActions = require("../state/RichTextEditorStateActions");

var _RichTextEditorControls = _interopRequireDefault(require("./RichTextEditorControls"));

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var ObjectTypes = _interopRequireWildcard(require("customer-data-objects/constants/ObjectTypes"));

var _EngagementTypes = require("customer-data-objects/engagement/EngagementTypes");

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _immutable = require("immutable");

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var associationMapIdToObjectType = {
  contactIds: ObjectTypes.CONTACT,
  companyIds: ObjectTypes.COMPANY,
  dealIds: ObjectTypes.DEAL,
  ticketIds: ObjectTypes.TICKET
};
var propTypes = {
  associations: _reactImmutableProptypes.default.map,
  cancelLabel: _react.PropTypes.node,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  config: _react.PropTypes.instanceOf(_RichTextEditorConfiguration.default).isRequired,
  contactVid: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  ControlsAreaComponent: _react.PropTypes.func,
  controlsAreaComponentProps: _react.PropTypes.object,
  controlsButtonsClassName: _react.PropTypes.string,
  controlsClassName: _react.PropTypes.string,
  controlSize: _react.PropTypes.string,
  controlsUse: _react.PropTypes.string,
  editorOptions: _react.PropTypes.object,
  editorState: _react.PropTypes.instanceOf(_draftJs.EditorState),
  focus: _react.PropTypes.bool,
  ignoreMoveFocus: _react.PropTypes.bool,
  inputClassName: _react.PropTypes.string,
  interactionType: _react.PropTypes.string,
  objectType: _ProfileObjectTypesType.default,
  onCancel: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  onContentChange: _react.PropTypes.func,
  onPaste: _react.PropTypes.func,
  onSave: _react.PropTypes.func,
  onSecondarySaveButtonClick: _react.PropTypes.func,
  onStateCreated: _react.PropTypes.func,
  overrideDrawStyle: _react.PropTypes.bool,
  owners: _react.PropTypes.array.isRequired,
  placeholder: _react.PropTypes.string,
  readOnly: _react.PropTypes.bool,
  renderTray: _react.PropTypes.func,
  resetInitialStateOnSave: _react.PropTypes.bool,
  saveDisabled: _react.PropTypes.bool,
  saveLabel: _react.PropTypes.node,
  saveOnEnter: _react.PropTypes.bool,
  saveTooltip: _react.PropTypes.shape({
    open: _react.PropTypes.bool,
    onClose: _react.PropTypes.func,
    placement: _react.PropTypes.string,
    headingText: _react.PropTypes.string,
    title: _react.PropTypes.string,
    use: _react.PropTypes.string,
    disabled: _react.PropTypes.bool
  }),
  secondarySaveButtonContent: _react.PropTypes.func,
  showCancel: _react.PropTypes.bool,
  showControls: _react.PropTypes.bool,
  showControlsBorder: _react.PropTypes.bool,
  showRTEBorder: _react.PropTypes.bool,
  subject: _SubjectType.default,
  unstyled: _react.PropTypes.bool,
  useTertiaryButtons: _react.PropTypes.bool,
  useStickyControls: _react.PropTypes.bool,
  onPluginOpenModal: _react.PropTypes.func,
  onPluginCloseModal: _react.PropTypes.func
};
var defaultProps = {
  associations: (0, _immutable.Map)(),
  editorOptions: {
    spellCheck: true
  },
  ignoreMoveFocus: false,
  onCancel: _emptyFunction.default,
  onChange: _emptyFunction.default,
  onContentChange: _emptyFunction.default,
  onPaste: _emptyFunction.default,
  onSave: _emptyFunction.default,
  onStateCreated: _emptyFunction.default,
  overrideDrawStyle: false,
  readOnly: false,
  resetInitialStateOnSave: true,
  saveDisabled: false,
  saveOnEnter: false,
  showCancel: true,
  showControls: false,
  showControlsBorder: false,
  unstyled: false,
  useTertiaryButtons: false,
  useStickyControls: false,
  onPluginOpenModal: _emptyFunction.default,
  onPluginCloseModal: _emptyFunction.default
};

var RichTextEditor =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(RichTextEditor, _PureComponent);

  function RichTextEditor(props) {
    var _this;

    (0, _classCallCheck2.default)(this, RichTextEditor);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RichTextEditor).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this)); // Note that getting the content is an expensive operation, debounced to avoid
    // frequent content checks

    _this.debouncedHasContent = (0, _debounce.default)(2000, function () {
      _this.setState({
        hasContent: _this.hasContent()
      });
    });
    _this.rteContentMediator = (0, _RichTextEditorStateActions.getRichTextEditorContentMediator)(props.config);
    _this.state = _this.createInitialComponentState(props);
    _this.EditorWithPlugins = _this.rteContentMediator.config(_draftExtend.Editor);
    return _this;
  }

  (0, _createClass2.default)(RichTextEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var editorState = this.state.editorState;
      this.setState({
        hasContent: this.hasContent()
      });
      this.props.onStateCreated(this.createRichTextEditorResults(editorState));

      if (this.props.focus) {
        this.refs.richTextEditor.focus();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.editorState !== this.props.editorState && nextProps.editorState !== this.state.editorState) {
        this.setState(this.createComponentState(nextProps));
      }

      if (this.props.config !== nextProps.config) {
        this.rteContentMediator = (0, _RichTextEditorStateActions.getRichTextEditorContentMediator)(nextProps.config);
        this.EditorWithPlugins = this.rteContentMediator.config(_draftExtend.Editor);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevProps.focus == null && this.props.focus) {
        this.refs.richTextEditor.focus();
      }

      if (prevProps.editorState !== this.props.editorState && prevState.editorState !== this.props.editorState) {
        if (this.isContentChanged(prevState.editorState)) {
          var editorState = this.state.editorState;
          var results = this.createRichTextEditorResults(editorState);
          this.props.onContentChange(results);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.debouncedHasContent.cancel();
    }
  }, {
    key: "createInitialComponentState",
    value: function createInitialComponentState(props) {
      var state = this.createComponentState(props);
      state.initialEditorState = state.editorState;
      return state;
    }
  }, {
    key: "createComponentState",
    value: function createComponentState(_ref) {
      var editorState = _ref.editorState;

      if (!editorState) {
        editorState = _draftJs.EditorState.createEmpty();
      } else if (this.props.interactionType !== _EngagementTypes.EMAIL && !this.props.ignoreMoveFocus) {
        editorState = _draftJs.EditorState.moveFocusToEnd(editorState);
      }

      var hasContent = editorState && this.hasContent(editorState);
      return {
        editorState: editorState,
        hasContent: hasContent
      };
    }
  }, {
    key: "isContentChanged",
    value: function isContentChanged(editorState) {
      return this.state.editorState.getCurrentContent().getBlockMap() !== editorState.getCurrentContent().getBlockMap();
    }
  }, {
    key: "createRichTextEditorResults",
    value: function createRichTextEditorResults(editorState) {
      return new _RichTextEditorResults.default({
        editorState: editorState,
        contentChanged: this.isContentChanged(editorState),
        contentMediator: this.rteContentMediator
      });
    }
  }, {
    key: "handleChange",
    value: function handleChange(editorState) {
      var _this$props = this.props,
          onChange = _this$props.onChange,
          onContentChange = _this$props.onContentChange;
      var hasContent = this.state.hasContent;
      var rteResult = this.createRichTextEditorResults(editorState);
      onChange(rteResult);

      if (rteResult.contentChanged) {
        onContentChange(rteResult);
      }

      if (!hasContent) {
        hasContent = this.hasContent(editorState);
      } else {
        this.debouncedHasContent();
      }

      this.setState({
        editorState: editorState,
        hasContent: hasContent
      });
    }
  }, {
    key: "handlePastedText",
    value: function handlePastedText(text, html) {
      if (html == null && text == null) {
        return false;
      }

      this.props.onPaste(html);
      return true;
    }
  }, {
    key: "handleSave",
    value: function handleSave() {
      var _this$props2 = this.props,
          saveDisabled = _this$props2.saveDisabled,
          resetInitialStateOnSave = _this$props2.resetInitialStateOnSave;

      if (saveDisabled) {
        return;
      }

      var editorState = this.state.editorState;
      var results = this.createRichTextEditorResults(editorState);

      if (resetInitialStateOnSave) {
        this.setState({
          initialEditorState: editorState
        });
      }

      this.props.onSave(results);
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.setState({
        editorState: this.state.initialEditorState
      });
      this.props.onCancel();
    }
  }, {
    key: "handleSecondarySave",
    value: function handleSecondarySave() {
      var results = this.createRichTextEditorResults(this.state.editorState);
      this.props.onSecondarySaveButtonClick(results);
    }
  }, {
    key: "getWrapperClassName",
    value: function getWrapperClassName() {
      return (0, _classnames.default)('rich-text-editor', this.props.className);
    }
  }, {
    key: "getInputClassName",
    value: function getInputClassName() {
      return (0, _classnames.default)('rich-text-editor-input', 'has--email-style-reset', {
        unstyled: this.props.unstyled,
        'rte-border': this.props.showRTEBorder
      }, this.props.inputClassName);
    }
  }, {
    key: "getContactVid",
    value: function getContactVid() {
      var _this$props3 = this.props,
          subject = _this$props3.subject,
          objectType = _this$props3.objectType,
          contactVid = _this$props3.contactVid;
      var subjectId = subject ? (0, _ImmutableModel.getId)(subject) : null;
      var contactVidAsNumber = Number(contactVid);

      if (contactVidAsNumber) {
        return contactVidAsNumber;
      }

      if (objectType === ObjectTypes.CONTACT) {
        return Number(subjectId);
      }

      return null;
    }
  }, {
    key: "getSubjectId",
    value: function getSubjectId() {
      var subject = this.props.subject;
      return subject ? "" + (0, _ImmutableModel.getId)(subject) : null;
    }
  }, {
    key: "hasContent",
    value: function hasContent() {
      var editorState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.editorState;
      return editorState && this.rteContentMediator.hasContent(editorState);
    }
  }, {
    key: "getSupplementalObjects",
    value: function getSupplementalObjects() {
      return this.props.associations.reduce(function (supplementalObjects, associationValues, associationKey) {
        var id = associationValues.first();

        if (id) {
          var key = associationMapIdToObjectType[associationKey];
          supplementalObjects[key] = id;
        }

        return supplementalObjects;
      }, {});
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          overrideDrawStyle = _this$props4.overrideDrawStyle,
          useTertiaryButtons = _this$props4.useTertiaryButtons,
          editorOptions = _this$props4.editorOptions,
          saveLabel = _this$props4.saveLabel,
          cancelLabel = _this$props4.cancelLabel,
          saveDisabled = _this$props4.saveDisabled,
          saveOnEnter = _this$props4.saveOnEnter,
          showControls = _this$props4.showControls,
          saveTooltip = _this$props4.saveTooltip,
          controlsClassName = _this$props4.controlsClassName,
          controlsButtonsClassName = _this$props4.controlsButtonsClassName,
          ControlsAreaComponent = _this$props4.ControlsAreaComponent,
          controlsAreaComponentProps = _this$props4.controlsAreaComponentProps,
          controlSize = _this$props4.controlSize,
          controlsUse = _this$props4.controlsUse,
          showControlsBorder = _this$props4.showControlsBorder,
          owners = _this$props4.owners,
          readOnly = _this$props4.readOnly,
          secondarySaveButtonContent = _this$props4.secondarySaveButtonContent,
          showCancel = _this$props4.showCancel,
          objectType = _this$props4.objectType,
          renderTray = _this$props4.renderTray,
          useStickyControls = _this$props4.useStickyControls,
          onPluginOpenModal = _this$props4.onPluginOpenModal,
          onPluginCloseModal = _this$props4.onPluginCloseModal;
      var editorState = this.state.editorState;
      var EditorWithPlugins = this.EditorWithPlugins;
      return _react.default.createElement(_RichTextEditorControls.default, {
        ControlsAreaComponent: ControlsAreaComponent,
        cancelLabel: cancelLabel,
        controlSize: controlSize,
        controlsAreaComponentProps: controlsAreaComponentProps,
        controlsButtonsClassName: controlsButtonsClassName,
        controlsClassName: controlsClassName,
        onCancel: this.handleCancel,
        onSave: this.handleSave,
        onSecondarySave: this.handleSecondarySave,
        open: showControls,
        overrideDrawStyle: overrideDrawStyle,
        saveDisabled: saveDisabled,
        saveLabel: saveLabel,
        saveOnEnter: saveOnEnter,
        saveTooltip: saveTooltip,
        secondarySaveButtonContent: secondarySaveButtonContent,
        showCancel: showCancel,
        showControlsBorder: showControlsBorder,
        use: controlsUse,
        useTertiaryButtons: useTertiaryButtons,
        useStickyControls: useStickyControls,
        wrapperClassName: this.getWrapperClassName()
      }, _react.default.createElement(EditorWithPlugins, (0, _extends2.default)({
        ref: "richTextEditor",
        className: this.getInputClassName(),
        editorState: editorState,
        onChange: this.handleChange,
        handlePastedText: this.handlePastedText,
        placeholder: this.props.placeholder,
        owners: owners,
        contactVid: this.getContactVid(),
        subjectId: this.getSubjectId(),
        objectType: objectType,
        readOnly: readOnly,
        renderTray: renderTray,
        supplementalObjects: this.getSupplementalObjects(),
        onPluginOpenModal: onPluginOpenModal,
        onPluginCloseModal: onPluginCloseModal
      }, editorOptions)), this.props.children);
    }
  }]);
  return RichTextEditor;
}(_PureComponent2.default);

RichTextEditor.propTypes = propTypes;
RichTextEditor.defaultProps = defaultProps;
var _default = RichTextEditor;
exports.default = _default;
module.exports = exports.default;